import React from 'react'
import { Button, Dialog, Flex, Text } from '@sendoutcards/quantum-design-ui'
import CallToActionCard from '../CallToActionCard'
import { CarouselCardImages } from './CarouselCardImages'
import { GreetingCardImageLinkType } from './GreetingCardImage'
import { useActions } from 'src/hooks'

type SystemPathDialogProps = {
  cards: GreetingCardImageLinkType[]
  isOpen: boolean
  onClose: () => void
}

export const SystemPathDialog: React.FC<SystemPathDialogProps> = ({
  cards,
  isOpen = false,
  onClose,
}) => {
  const actions = useActions()
  const darkThemeButtonBackground = '#4D4D4D'
  return (
    <Dialog isOpen={isOpen} onClose={onClose} insetOverride="x0">
      <CallToActionCard
        isContentCentered={true}
        theme="dark"
        tag={{
          icon: 'heartfelt',
          iconColor: 'pink',
          title: 'System Cards',
        }}
        title="Create a System Card"
        titleSize="subtitle"
        caption="System Cards are the best option for customer follow-up, scheduling out campaigns, invitations, and more! Select your path to get started today."
        graphic={
          <CarouselCardImages
            cardHeight="245px"
            cardWidth="175px"
            gap="40px"
            cardRadius={12}
            cards={cards}
          />
        }
        graphicOrder={2}
        graphicBackground={{ image: '', color: '#BE9CDD' }}
        isStacked={true}
        actions={
          <Flex
            alignItems={'center'}
            justifyContent={'center'}
            style={{ gap: 16 }}
            outset={{ vertical: 'x2' }}
          >
            <Button
              title="Add Contacts"
              onClick={() => actions.openRelationshipManager()}
              backgroundColorOverride={'#FFFFFF'}
              outlined={true}
              size="small"
            />
            <Text color={'inverseBody'} type="caption" content="or" />
            <Button
              title="Build a Campaign"
              onClick={() => actions.openCampaigns({ path: 'my-campaigns' })}
              backgroundColorOverride={darkThemeButtonBackground}
              size="small"
            />
          </Flex>
        }
      />
    </Dialog>
  )
}
